'use client';
import React, { useRef } from 'react';
import BackToTopButton from '@/components/landingPage/BackToTopButton';
import Logo from './Logo';

const Footer = () => {
  const footerRef = useRef(null);

  const openCookieSettings = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (window?.__ucCmp) {
      window.__ucCmp.showSecondLayer();
    } else {
      console.log('UserCentrics not found');
    }
  };

  return (
    <>
      <BackToTopButton footerRef={footerRef} />
      <footer ref={footerRef} className="mainFooter">
        <div className="flyntComponent themeDark" is="flynt-navigation-footer-small">
          <div className="container centerMaxWidthContainer">
            <Logo className="footer-logo footer-logo--mobile" />
            <div className="footer-secondary">
              <Logo className="footer-logo footer-logo--desktop" />
              <nav className="navigation" aria-label="Footer Secondary">
                <ul className="menu menu--level-0">
                  <li className="menu-item">
                    <a
                      className="menu-link"
                      href="https://oviva.com/de/de/impressum/"
                      aria-label="Impressum"
                    >
                      Impressum
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className="menu-link"
                      href="https://oviva.com/de/de/datenschutzbestimmungen-deutschland/"
                      aria-label="Datenschutz"
                    >
                      Datenschutz
                    </a>
                  </li>
                  <li className="menu-item">
                    <a className="menu-link" href="https://oviva.com/de/de/agb/" aria-label="AGB">
                      AGB
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className="menu-link"
                      href="https://oviva.com/de/de/benutzerhandbuch/"
                      aria-label="Benutzerhandbuch"
                    >
                      Benutzerhandbuch
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className="menu-link"
                      href="https://status.oviva.com/"
                      aria-label="Systemstatus"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Systemstatus
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className="menu-link"
                      href="https://oviva.com/de/de/direkt-rechtliche-hinweise-ueberblick/"
                      aria-label="Oviva Direkt Rechtliche Hinweise"
                    >
                      Oviva Direkt Rechtliche Hinweise
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className="menu-link"
                      role="button"
                      href="#"
                      onClick={openCookieSettings}
                      aria-label="Cookie-Einstellungen"
                    >
                      Cookie-Einstellungen
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className="menu-link"
                      href="https://oviva.com/de/de/support/?utm_source=website&utm_medium=footer"
                      aria-label="FAQs & Kontakt"
                    >
                      FAQs & Kontakt
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
